import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading", {
            center: _ctx.centerAligned
        }]),
    style: _normalizeStyle({
            width: `${_ctx.size}px`,
            height: `${_ctx.size}px`,
            margin: `${_ctx.margin}px`,
        })
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      class: "spinner spinner-border text-light align-middle align-items-center",
      role: "status"
    }, [
      _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ], -1)
  ]), 6))
}